import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft, Share2, ChevronDown } from 'lucide-react';
import { Helmet } from 'react-helmet-async';
import { RelatedBlogPosts } from '../../../../components/Blog/RelatedBlogPosts';
import { GoogleTranslateWidget } from '../../../../components/GoogleTranslateWidget';
export function BlogPost7SignsGaslightingDE() {
  const articleData = {
    title: '7 Anzeichen von Gaslighting, die unsere KI sofort erkennt',
    description: 'Entdecken Sie 7 Anzeichen von Gaslighting, die unsere KI sofort erkennt. Laden Sie Ihre Texte hoch, um Manipulation, Leugnung und emotionale Missbrauchsmuster in Sekunden zu erkennen.',
    slug: '7-signs-of-gaslighting',
    publishDate: '2025-01-14',
    author: 'Toxic Detector Redaktion'
  };
  const alternateUrls = [{
    lang: 'en',
    url: 'https://toxicdetector.com/blog/7-signs-of-gaslighting'
  }, {
    lang: 'pt-BR',
    url: 'https://toxicdetector.com/pt/blog/7-signs-of-gaslighting'
  }, {
    lang: 'es-MX',
    url: 'https://toxicdetector.com/es/blog/7-signs-of-gaslighting'
  }, {
    lang: 'ja',
    url: 'https://toxicdetector.com/ja/blog/7-signs-of-gaslighting'
  }, {
    lang: 'ko',
    url: 'https://toxicdetector.com/ko/blog/7-signs-of-gaslighting'
  }, {
    lang: 'de',
    url: 'https://toxicdetector.com/de/blog/7-signs-of-gaslighting'
  }, {
    lang: 'fr',
    url: 'https://toxicdetector.com/fr/blog/7-signs-of-gaslighting'
  }, {
    lang: 'hi',
    url: 'https://toxicdetector.com/hi/blog/7-signs-of-gaslighting'
  }, {
    lang: 'id',
    url: 'https://toxicdetector.com/id/blog/7-signs-of-gaslighting'
  }];
  const handleShare = async () => {
    try {
      await navigator.share({
        title: articleData.title,
        text: articleData.description,
        url: window.location.href
      });
    } catch (err) {
      navigator.clipboard.writeText(window.location.href);
      alert('Link in die Zwischenablage kopiert!');
    }
  };
  const faqSchema = {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: [{
      '@type': 'Question',
      name: 'Was sind die frühesten Anzeichen von Gaslighting in einer Beziehung?',
      acceptedAnswer: {
        '@type': 'Answer',
        text: 'Frühe Anzeichen sind das Leugnen von Ereignissen, Verdrehung von Fakten, Minimierung Ihrer Gefühle und Schuldzuweisungen. Diese Muster lassen Sie allmählich an Ihrer Wahrnehmung zweifeln.'
      }
    }, {
      '@type': 'Question',
      name: 'Kann Gaslighting wirklich über Textnachrichten passieren?',
      acceptedAnswer: {
        '@type': 'Answer',
        text: 'Ja. Gaslighting über Text ist sehr häufig. Nachrichten können manipulativ sein, Fakten verzerren oder Schuldgefühle erzeugen. Unsere KI erkennt diese Muster sofort anhand Ihres Chatverlaufs.'
      }
    }, {
      '@type': 'Question',
      name: 'Wie erkennt die KI von Toxic Detector Gaslighting-Muster?',
      acceptedAnswer: {
        '@type': 'Answer',
        text: 'Toxic Detector analysiert Tonwechsel, Widersprüche, Schuldmuster, emotionale Minimierung, Schuld erzeugende Sprache sowie Unterschiede im Verhalten in der Öffentlichkeit und Privat.'
      }
    }, {
      '@type': 'Question',
      name: 'Was ist der Unterschied zwischen Gaslighting und normalen Meinungsverschiedenheiten?',
      acceptedAnswer: {
        '@type': 'Answer',
        text: 'Normale Meinungsverschiedenheiten beinhalten zwei Perspektiven. Gaslighting beinhaltet absichtliche oder wiederholte Versuche, Ihre Realität zu verzerren, Ihre Gefühle zu entwerten oder Sie an Ihrem Verstand zweifeln zu lassen.'
      }
    }, {
      '@type': 'Question',
      name: 'Warum betreiben Menschen Gaslighting in Beziehungen?',
      acceptedAnswer: {
        '@type': 'Answer',
        text: 'Gaslighter wollen oft Kontrolle, vermeiden Verantwortung oder manipulieren die Emotionen ihres Partners. Viele wiederholen erlernte Muster, ohne den Schaden zu erkennen.'
      }
    }, {
      '@type': 'Question',
      name: 'Kann Gaslighting unbeabsichtigt sein?',
      acceptedAnswer: {
        '@type': 'Answer',
        text: 'Ja, manche Menschen betreiben Gaslighting, ohne es zu merken. Das Verhalten kann aus Unsicherheit, Vermeidung oder erlernten toxischen Kommunikationsgewohnheiten stammen.'
      }
    }, {
      '@type': 'Question',
      name: 'Was sollte ich tun, wenn ich denke, mein Partner betreibt Gaslighting?',
      acceptedAnswer: {
        '@type': 'Answer',
        text: 'Vertrauen Sie Ihrem Instinkt, dokumentieren Sie Gespräche, sprechen Sie mit einer vertrauenswürdigen Person und ziehen Sie professionelle Hilfe in Betracht. Tools wie Toxic Detector können Muster bestätigen.'
      }
    }, {
      '@type': 'Question',
      name: 'Ist Gaslighting eine Form von emotionalem Missbrauch?',
      acceptedAnswer: {
        '@type': 'Answer',
        text: 'Ja. Gaslighting wird als Form von psychischem und emotionalem Missbrauch anerkannt, da es die Wahrnehmung der Realität manipuliert.'
      }
    }, {
      '@type': 'Question',
      name: 'Wie genau ist Toxic Detector beim Aufspüren von Manipulation?',
      acceptedAnswer: {
        '@type': 'Answer',
        text: 'Unsere KI analysiert sprachliche, tonale und verhaltensbezogene Muster in Ihren Nachrichten sehr genau und liefert klare, teilbare Berichte auf Basis konsistenter Verhaltensanalyse.'
      }
    }, {
      '@type': 'Question',
      name: 'Verschlimmert sich Gaslighting mit der Zeit?',
      acceptedAnswer: {
        '@type': 'Answer',
        text: 'Gaslighting eskaliert oft allmählich. Wenn das Opfer verwirrter oder abhängiger wird, erhöht der Manipulator die Kontrolle und verstärkt den emotionalen Druck.'
      }
    }]
  };
  const articleSchema = {
    '@context': 'https://schema.org',
    '@type': 'Article',
    headline: articleData.title,
    description: articleData.description,
    image: 'https://uploadthingy.s3.us-west-1.amazonaws.com/89an98a4aCmEYGiFGxbV6q/1763120076017.jpg',
    datePublished: articleData.publishDate,
    author: {
      '@type': 'Organization',
      name: articleData.author
    },
    publisher: {
      '@type': 'Organization',
      name: 'ToxicDetector',
      logo: {
        '@type': 'ImageObject',
        url: 'https://toxicdetector.com/images/logo.png'
      }
    }
  };
  return <div className="min-h-screen bg-gray-50" data-id="element-4228">
      <GoogleTranslateWidget data-id="element-4229" />
      <Helmet data-id="element-4230">
        <title data-id="element-4231">
          7 Anzeichen von Gaslighting (KI erkannt) — Stoppen Sie die
          Manipulation | ToxicDetector
        </title>
        <meta name="description" content="Denken Sie, jemand betreibt Gaslighting mit Ihnen? Unsere KI erkennt die 7 wichtigsten Anzeichen sofort, indem sie Ihre Chats analysiert." data-id="element-4232" />
        <meta name="keywords" content="Anzeichen von Gaslighting, Gaslighting-Beispiele, Gaslighting in Textnachrichten, Gaslighting-Verhalten, Beziehungsmanipulation, KI Gaslighting-Detektor" data-id="element-4233" />
        <meta name="language" content="de" data-id="element-4234" />
        <link rel="canonical" href="https://toxicdetector.com/de/blog/7-signs-of-gaslighting" data-id="element-4235" />
        {alternateUrls.map(alternate => <link key={alternate.lang} rel="alternate" hrefLang={alternate.lang} href={alternate.url} data-id="element-4236" />)}
        <meta property="og:type" content="article" data-id="element-4237" />
        <meta property="og:title" content="7 Anzeichen von Gaslighting, die unsere KI sofort erkennt" data-id="element-4238" />
        <meta property="og:description" content="Denken Sie, jemand betreibt Gaslighting mit Ihnen? Unsere KI erkennt die 7 wichtigsten Anzeichen sofort." data-id="element-4239" />
        <meta property="og:url" content="https://toxicdetector.com/de/blog/7-signs-of-gaslighting" data-id="element-4240" />
        <meta property="og:image" content="https://cdn.magicpatterns.com/uploads/9AgsYP8bczHQvssTJAPniL/file_00000000842c7243a7657dadb3d089c4.png" data-id="element-4241" />
        <meta property="og:locale" content="de" data-id="element-4242" />
        <meta name="twitter:card" content="summary_large_image" data-id="element-4243" />
        <meta name="twitter:title" content="7 Anzeichen von Gaslighting (KI erkannt)" data-id="element-4244" />
        <meta name="twitter:description" content="Unsere KI erkennt die 7 wichtigsten Anzeichen von Gaslighting sofort durch die Analyse Ihrer Chats." data-id="element-4245" />
        <meta name="twitter:image" content="https://uploadthingy.s3.us-west-1.amazonaws.com/89an98a4aCmEYGiFGxbV6q/1763120076017.jpg" data-id="element-4246" />
        <script type="application/ld+json" data-id="element-4247">
          {JSON.stringify(articleSchema)}
        </script>
        <script type="application/ld+json" data-id="element-4248">{JSON.stringify(faqSchema)}</script>
      </Helmet>

      <div className="flex flex-col w-full min-h-screen bg-gradient-to-b from-stone-50 to-white" data-id="element-4249">
        <header className="bg-white/90 border-b border-gray-200 sticky top-0 z-50 backdrop-blur-sm" data-id="element-4250">
          <div className="max-w-3xl mx-auto px-6 py-4" data-id="element-4251">
            <div className="flex items-center justify-between" data-id="element-4252">
              <Link to="/" className="text-2xl font-bold tracking-tight text-gray-900" data-id="element-4253">
                🚩 ToxicDetector
              </Link>
              <button onClick={handleShare} className="p-2.5 hover:bg-gray-50 rounded-lg transition-colors" aria-label="Artikel teilen" data-id="element-4254">
                <Share2 size={20} className="text-gray-600" data-id="element-4255" />
              </button>
            </div>
          </div>
        </header>

        <article className="max-w-3xl mx-auto w-full px-6 py-12" data-id="element-4256">
          <Link to="/blog" className="inline-flex items-center text-gray-600 text-sm mb-10 hover:text-gray-900 transition-colors group" data-id="element-4257">
            <ArrowLeft size={16} className="mr-2 group-hover:-translate-x-1 transition-transform" data-id="element-4258" />
            Zurück zum Blog
          </Link>

          <header className="mb-12" data-id="element-4259">
            <h1 className="text-4xl md:text-5xl font-bold mb-6 tracking-tight leading-tight text-gray-900" data-id="element-4260">
              {articleData.title}
            </h1>
            <div className="flex items-center text-gray-600 text-sm gap-3" data-id="element-4261">
              <time dateTime={articleData.publishDate} data-id="element-4262">
                {new Date(articleData.publishDate).toLocaleDateString('de-DE', {
                year: 'numeric',
                month: 'long',
                day: 'numeric'
              })}
              </time>
              <span className="text-gray-300" data-id="element-4263">•</span>
              <span data-id="element-4264">{articleData.author}</span>
            </div>
          </header>

          <div className="mb-12" data-id="element-4265">
            <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/89an98a4aCmEYGiFGxbV6q/1763120076017.jpg" alt="KI erkennt Anzeichen von Gaslighting in Beziehungstexten" className="w-full rounded-2xl shadow-sm border border-gray-200" data-id="element-4266" />
          </div>

          <div className="bg-white rounded-xl p-6 border border-gray-200 mb-12" data-id="element-4267">
            <h2 className="font-bold text-lg mb-4 text-gray-900" data-id="element-4268">
              Inhaltsverzeichnis
            </h2>
            <ul className="space-y-3 text-sm" data-id="element-4269">
              <li data-id="element-4270">
                <a href="#denying" className="text-gray-600 hover:text-gray-900 transition-colors flex items-center gap-2" data-id="element-4271">
                  <span className="text-gray-400" data-id="element-4272">→</span> 1. Leugnen, was
                  passiert ist
                </a>
              </li>
              <li data-id="element-4273">
                <a href="#twisting" className="text-gray-600 hover:text-gray-900 transition-colors flex items-center gap-2" data-id="element-4274">
                  <span className="text-gray-400" data-id="element-4275">→</span> 2. Fakten verdrehen
                </a>
              </li>
              <li data-id="element-4276">
                <a href="#trivializing" className="text-gray-600 hover:text-gray-900 transition-colors flex items-center gap-2" data-id="element-4277">
                  <span className="text-gray-400" data-id="element-4278">→</span> 3. Gefühle
                  trivialisieren
                </a>
              </li>
              <li data-id="element-4279">
                <a href="#shifting" className="text-gray-600 hover:text-gray-900 transition-colors flex items-center gap-2" data-id="element-4280">
                  <span className="text-gray-400" data-id="element-4281">→</span> 4. Schuldverschiebung
                </a>
              </li>
              <li data-id="element-4282">
                <a href="#victim" className="text-gray-600 hover:text-gray-900 transition-colors flex items-center gap-2" data-id="element-4283">
                  <span className="text-gray-400" data-id="element-4284">→</span> 5. Das Opfer spielen
                </a>
              </li>
              <li data-id="element-4285">
                <a href="#overtime" className="text-gray-600 hover:text-gray-900 transition-colors flex items-center gap-2" data-id="element-4286">
                  <span className="text-gray-400" data-id="element-4287">→</span> 6. Gaslighting über
                  Zeit
                </a>
              </li>
              <li data-id="element-4288">
                <a href="#tone" className="text-gray-600 hover:text-gray-900 transition-colors flex items-center gap-2" data-id="element-4289">
                  <span className="text-gray-400" data-id="element-4290">→</span> 7. Tonwechsel
                  Öffentlich vs Privat
                </a>
              </li>
              <li data-id="element-4291">
                <a href="#faq" className="text-gray-600 hover:text-gray-900 transition-colors flex items-center gap-2" data-id="element-4292">
                  <span className="text-gray-400" data-id="element-4293">→</span> Häufig gestellte
                  Fragen
                </a>
              </li>
            </ul>
          </div>

          <div className="prose prose-lg max-w-none" data-id="element-4294">
            <p className="text-xl mb-8 leading-relaxed text-gray-700" data-id="element-4295">
              Haben Sie jemals das Gefühl, in einer Beziehung den Verstand zu
              verlieren? 🚩 Vielleicht sagt Ihr Partner eine Sache, aber Ihr
              Bauchgefühl sagt etwas anderes. Das nennt man{' '}
              <strong data-id="element-4296">Gaslighting</strong>, ein subtiles, manipulatives
              Verhalten, das darauf ausgelegt ist, Sie an sich selbst zweifeln
              zu lassen.
            </p>
            <p className="mb-12 text-lg leading-relaxed text-gray-600" data-id="element-4297">
              Die meisten Menschen übersehen die Anzeichen von Gaslighting, aber
              unsere KI erkennt es sofort, indem sie Ihre Chats analysiert, um
              die Wahrheit zu enthüllen. Hier sind 7 Anzeichen von Gaslighting,
              die unsere KI erkennt, damit Sie es nicht müssen.
            </p>

            <section id="denying" className="mb-12" data-id="element-4298">
              <h2 className="text-3xl font-bold mb-6 tracking-tight text-gray-900" data-id="element-4299">
                1️⃣ Leugnen, was passiert ist
              </h2>
              <div className="bg-gray-50 border-l-4 border-purple-600 p-6 mb-6 rounded-r-xl" data-id="element-4300">
                <p className="italic text-gray-700 text-lg" data-id="element-4301">
                  "Das habe ich nie gesagt."
                </p>
              </div>
              <p className="text-lg leading-relaxed text-gray-600" data-id="element-4302">
                Kommt Ihnen das bekannt vor? Gaslighter leugnen oft Fakten oder
                Ereignisse, um Sie zu verwirren. Die KI erkennt wiederholte
                Widersprüche und markiert Nachrichten, die versuchen, die
                Realität auszulöschen.
              </p>
            </section>

            <section id="twisting" className="mb-12" data-id="element-4303">
              <h2 className="text-3xl font-bold mb-6 tracking-tight text-gray-900" data-id="element-4304">
                2️⃣ Fakten verdrehen
              </h2>
              <div className="bg-gray-50 border-l-4 border-purple-600 p-6 mb-6 rounded-r-xl" data-id="element-4305">
                <p className="italic text-gray-700 text-lg" data-id="element-4306">
                  "Du bildest dir das nur ein."
                </p>
              </div>
              <p className="text-lg leading-relaxed text-gray-600" data-id="element-4307">
                Dieser klassische Zug lässt Sie an Ihrem Gedächtnis zweifeln.
                Die KI markiert, wenn Nachrichten manipuliert oder selektiv
                umgedeutet werden, um Sie zweifeln zu lassen.
              </p>
            </section>

            <section id="trivializing" className="mb-12" data-id="element-4308">
              <h2 className="text-3xl font-bold mb-6 tracking-tight text-gray-900" data-id="element-4309">
                3️⃣ Gefühle trivialisieren
              </h2>
              <div className="bg-gray-50 border-l-4 border-purple-600 p-6 mb-6 rounded-r-xl" data-id="element-4310">
                <p className="italic text-gray-700 text-lg" data-id="element-4311">
                  "Du bist zu empfindlich."
                </p>
              </div>
              <p className="text-lg leading-relaxed text-gray-600" data-id="element-4312">
                Ihre Emotionen zu minimieren ist ein riesiges Warnsignal. Die KI
                erkennt Tonmuster, die Ihre Gefühle abtun oder abwerten.
              </p>
            </section>

            <section id="shifting" className="mb-12" data-id="element-4313">
              <h2 className="text-3xl font-bold mb-6 tracking-tight text-gray-900" data-id="element-4314">
                4️⃣ Schuldverschiebung
              </h2>
              <div className="bg-gray-50 border-l-4 border-purple-600 p-6 mb-6 rounded-r-xl" data-id="element-4315">
                <p className="italic text-gray-700 text-lg" data-id="element-4316">
                  "Das ist deine Schuld."
                </p>
              </div>
              <p className="text-lg leading-relaxed text-gray-600" data-id="element-4317">
                Ist Ihnen aufgefallen, dass Streitigkeiten immer "Ihre Schuld"
                sind? Die KI hebt wiederholte Versuche hervor, die Verantwortung
                zu verschieben, damit Sie das Muster klar erkennen können.
              </p>
            </section>

            <section id="victim" className="mb-12" data-id="element-4318">
              <h2 className="text-3xl font-bold mb-6 tracking-tight text-gray-900" data-id="element-4319">
                5️⃣ Das Opfer spielen
              </h2>
              <div className="bg-gray-50 border-l-4 border-purple-600 p-6 mb-6 rounded-r-xl" data-id="element-4320">
                <p className="italic text-gray-700 text-lg" data-id="element-4321">
                  "Nach allem, was ich für dich tue..."
                </p>
              </div>
              <p className="text-lg leading-relaxed text-gray-600" data-id="element-4322">
                Schuldgefühle sind eine subtile Form der Kontrolle. Die KI
                markiert manipulative Formulierungen, die darauf ausgelegt sind,
                dass Sie sich schlecht fühlen oder sich übermäßig entschuldigen.
              </p>
            </section>

            <section id="overtime" className="mb-12" data-id="element-4323">
              <h2 className="text-3xl font-bold mb-6 tracking-tight text-gray-900" data-id="element-4324">
                6️⃣ Gaslighting über Zeit ⏳
              </h2>
              <p className="text-lg leading-relaxed text-gray-600" data-id="element-4325">
                Gaslighting ist nicht immer offensichtlich. Es baut sich
                allmählich auf. Die KI verfolgt Muster über mehrere Gespräche
                hinweg und gibt Ihnen einen Überblick über toxisches Verhalten.
              </p>
            </section>

            <section id="tone" className="mb-12" data-id="element-4326">
              <h2 className="text-3xl font-bold mb-6 tracking-tight text-gray-900" data-id="element-4327">
                7️⃣ Tonwechsel Öffentlich vs Privat
              </h2>
              <div className="bg-gray-50 border-l-4 border-purple-600 p-6 mb-6 rounded-r-xl" data-id="element-4328">
                <p className="italic text-gray-700 text-lg" data-id="element-4329">
                  Gruppenchat: 😊 / 1:1: 😡
                </p>
              </div>
              <p className="text-lg leading-relaxed text-gray-600" data-id="element-4330">
                Manche Gaslighter verhalten sich öffentlich anders als in
                privaten Nachrichten. Die KI erkennt Diskrepanzen und hebt
                plötzliche Stimmungsschwankungen oder versteckte Aggression
                hervor.
              </p>
            </section>

            <section className="mb-12" data-id="element-4331">
              <h2 className="text-3xl font-bold mb-6 tracking-tight text-gray-900" data-id="element-4332">
                🛡 Wie Sie sich schützen können
              </h2>
              <div className="bg-white rounded-xl border border-gray-200 p-6" data-id="element-4333">
                <ul className="space-y-3 text-lg text-gray-600" data-id="element-4334">
                  <li className="flex items-start gap-3" data-id="element-4335">
                    <span className="text-purple-600 font-bold" data-id="element-4336">•</span>
                    <span data-id="element-4337">Vertrauen Sie Ihrem Instinkt.</span>
                  </li>
                  <li className="flex items-start gap-3" data-id="element-4338">
                    <span className="text-purple-600 font-bold" data-id="element-4339">•</span>
                    <span data-id="element-4340">Bewahren Sie Gesprächsprotokolle auf.</span>
                  </li>
                  <li className="flex items-start gap-3" data-id="element-4341">
                    <span className="text-purple-600 font-bold" data-id="element-4342">•</span>
                    <span data-id="element-4343">Sprechen Sie mit einem Freund oder Therapeuten.</span>
                  </li>
                  <li className="flex items-start gap-3" data-id="element-4344">
                    <span className="text-purple-600 font-bold" data-id="element-4345">•</span>
                    <span data-id="element-4346">
                      Am wichtigsten: Ignorieren Sie keine Warnsignale.
                    </span>
                  </li>
                </ul>
              </div>
            </section>

            <section className="mb-12" data-id="element-4347">
              <h2 className="text-3xl font-bold mb-6 tracking-tight text-gray-900" data-id="element-4348">
                💀 Warum unsere KI funktioniert
              </h2>
              <p className="mb-6 text-lg leading-relaxed text-gray-600" data-id="element-4349">
                Im Gegensatz zu einem Menschen oder einem generischen Chatbot
                bietet Toxic Detector:
              </p>
              <div className="bg-white rounded-xl border border-gray-200 p-6 mb-6" data-id="element-4350">
                <ul className="space-y-3 text-lg text-gray-600" data-id="element-4351">
                  <li className="flex items-start gap-3" data-id="element-4352">
                    <span className="text-purple-600 font-bold" data-id="element-4353">•</span>
                    <span data-id="element-4354">Screenshot-Upload mit einem Fingertipp</span>
                  </li>
                  <li className="flex items-start gap-3" data-id="element-4355">
                    <span className="text-purple-600 font-bold" data-id="element-4356">•</span>
                    <span data-id="element-4357">Sofortige, teilbare Ergebnisse</span>
                  </li>
                  <li className="flex items-start gap-3" data-id="element-4358">
                    <span className="text-purple-600 font-bold" data-id="element-4359">•</span>
                    <span data-id="element-4360">
                      Emotionale, nachvollziehbare Ergebnisse, denen Sie
                      vertrauen können
                    </span>
                  </li>
                </ul>
              </div>
              <p className="text-lg font-semibold text-gray-900" data-id="element-4361">
                Hören Sie auf zu rätseln. Fangen Sie an zu wissen. 💖
              </p>
            </section>

            <section id="faq" className="mb-12" data-id="element-4362">
              <h2 className="text-3xl font-bold mb-8 tracking-tight text-gray-900" data-id="element-4363">
                Häufig gestellte Fragen
              </h2>
              <div className="space-y-4" data-id="element-4364">
                {faqSchema.mainEntity.map((faq, index) => <details key={index} className="bg-white rounded-xl border border-gray-200 overflow-hidden group" data-id="element-4365">
                    <summary className="px-6 py-4 cursor-pointer font-semibold text-base text-gray-900 hover:bg-gray-50 transition-colors flex items-center justify-between" data-id="element-4366">
                      <span data-id="element-4367">{faq.name}</span>
                      <ChevronDown size={20} className="text-gray-400 group-open:rotate-180 transition-transform" data-id="element-4368" />
                    </summary>
                    <div className="px-6 pb-4 text-gray-600 leading-relaxed text-sm" data-id="element-4369">
                      {faq.acceptedAnswer.text}
                    </div>
                  </details>)}
              </div>
            </section>
          </div>

          <div className="bg-purple-600 rounded-2xl p-10 text-center text-white mt-16" data-id="element-4370">
            <h2 className="text-3xl font-bold mb-4 tracking-tight" data-id="element-4371">
              💀 Bereit, die Wahrheit zu sehen?
            </h2>
            <p className="text-purple-100 mb-8 text-lg leading-relaxed max-w-2xl mx-auto" data-id="element-4372">
              Gaslighting ist subtil, gefährlich und anstrengend, aber unsere KI
              kann es kristallklar machen. Laden Sie Ihre Chats hoch und
              erhalten Sie Ihren sofortigen Toxizitätsbericht.
            </p>
            <div className="bg-white/10 backdrop-blur-sm rounded-xl p-6 mb-8 border border-white/20" data-id="element-4373">
              <p className="font-bold text-xl" data-id="element-4374">
                "🚩 83% toxisch. Vorsicht vor Manipulation!"
              </p>
            </div>
            <Link to="/signup" className="inline-block bg-white text-purple-600 px-10 py-4 rounded-lg font-bold text-lg hover:bg-gray-50 transition-colors" data-id="element-4375">
              Scannen Sie Ihre Chats jetzt →
            </Link>
          </div>

          <RelatedBlogPosts posts={[{
          title: 'Lerne die Begriffe: Narzissmus & Gaslighting',
          description: 'Verstehe die Psychologie hinter Narzissmus und Gaslighting-Manipulationstaktiken.',
          slug: 'narcissism-gaslighting-explained',
          emoji: '💀'
        }, {
          title: 'Ist dein Ex ein verdeckter Narzisst?',
          description: 'Entdecke, ob dein Ex Anzeichen von verdecktem narzisstischem Verhalten in Texten zeigt.',
          slug: 'is-your-ex-a-covert-narcissist',
          emoji: '🎭'
        }]} data-id="element-4376" />

          <div className="mt-12 text-center" data-id="element-4377">
            <button onClick={handleShare} className="inline-flex items-center text-gray-600 hover:text-gray-900 font-medium transition-colors text-sm" data-id="element-4378">
              <Share2 size={18} className="mr-2" data-id="element-4379" />
              Diesen Artikel teilen
            </button>
          </div>
        </article>

        <footer className="bg-white border-t border-gray-200 py-12 mt-16" data-id="element-4380">
          <div className="max-w-3xl mx-auto px-6 text-center" data-id="element-4381">
            <p className="text-gray-500 text-sm" data-id="element-4382">
              © {new Date().getFullYear()} ToxicDetector. Alle Rechte
              vorbehalten.
            </p>
          </div>
        </footer>
      </div>
    </div>;
}